module.exports = __webpack_public_path__ + "static/media/manageyourcity.658e250e.svg";